import {Action} from 'redux';

export type SET_SELECTED_CIDN_GLOBALLY = 'SET_SELECTED_CIDN_GLOBALLY';
export const SET_SELECTED_CIDN_GLOBALLY: SET_SELECTED_CIDN_GLOBALLY = 'SET_SELECTED_CIDN_GLOBALLY';

export interface ISetSelectedCidnGloballyAction extends Action {
    type: SET_SELECTED_CIDN_GLOBALLY,
    selectedCidn: string
}

export type SetSelectedCidnGloballyInvoke = (selectedCidn: string) => ISetSelectedCidnGloballyAction;

export const setSelectedCidnGlobally: SetSelectedCidnGloballyInvoke =
    (selectedCidn: string): ISetSelectedCidnGloballyAction => ({
        type: SET_SELECTED_CIDN_GLOBALLY,
        selectedCidn
    })
